import React, { useState, useEffect, useCallback } from 'react';

const DS_API = 'https://api.gp-pay.net';

function authHeaders() {
    const token = localStorage.getItem('ds_token');
    const adminId = localStorage.getItem('adminId');
    if (token) return { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
    // পুরনো system এ master login আছে — adminId header দিয়ে verify হবে
    if (adminId) return { 'Content-Type': 'application/json', 'x-admin-id': adminId };
    return { 'Content-Type': 'application/json' };
}

function isMasterAuth() {
    const dsRole = localStorage.getItem('ds_role');
    const dsToken = localStorage.getItem('ds_token');
    const oldMaster = localStorage.getItem('isMaster') === 'true' && !!localStorage.getItem('adminId');
    return oldMaster || (dsToken && dsRole === 'master');
}

function logout() {
    localStorage.removeItem('ds_token');
    localStorage.removeItem('ds_role');
    localStorage.removeItem('ds_username');
    window.location.href = '/debit_security';
}

export default function DSMasterDashboard() {
    const [admins, setAdmins] = useState([]);
    const [loading, setLoading] = useState(true);
    const [msg, setMsg] = useState('');
    const [msgType, setMsgType] = useState('');

    // Create form
    const [form, setForm] = useState({ username: '', password: '', website_code: '' });
    const [creating, setCreating] = useState(false);

    // Edit modal
    const [editAdmin, setEditAdmin] = useState(null);
    const [editForm, setEditForm] = useState({ website_code: '', password: '', is_active: true });
    const [saving, setSaving] = useState(false);

    const showMsg = (text, type = 'success') => {
        setMsg(text); setMsgType(type);
        setTimeout(() => setMsg(''), 3500);
    };

    const loadAdmins = useCallback(async () => {
        setLoading(true);
        try {
            const res = await fetch(`${DS_API}/debit_security/api/master/admins`, { headers: authHeaders() });
            if (res.status === 401) return logout();
            const data = await res.json();
            if (data.success) setAdmins(data.admins);
        } catch { showMsg('Admin লিস্ট লোড হয়নি', 'error'); }
        finally { setLoading(false); }
    }, []);

    useEffect(() => {
        if (!isMasterAuth()) { window.location.href = '/debit_security'; return; }
        loadAdmins();
    }, [loadAdmins]);

    const handleCreate = async (e) => {
        e.preventDefault();
        if (!form.username || !form.password || !form.website_code) {
            return showMsg('সব ঘর পূরণ করো', 'error');
        }
        setCreating(true);
        try {
            const res = await fetch(`${DS_API}/debit_security/api/master/create-admin`, {
                method: 'POST', headers: authHeaders(), body: JSON.stringify(form)
            });
            const data = await res.json();
            if (data.success) {
                showMsg('Admin তৈরি হয়েছে!');
                setForm({ username: '', password: '', website_code: '' });
                loadAdmins();
            } else { showMsg(data.message || 'তৈরি ব্যর্থ', 'error'); }
        } catch { showMsg('Server error', 'error'); }
        finally { setCreating(false); }
    };

    const openEdit = (admin) => {
        setEditAdmin(admin);
        setEditForm({ website_code: admin.website_code, password: '', is_active: admin.is_active });
    };

    const handleSaveEdit = async () => {
        setSaving(true);
        try {
            const body = { website_code: editForm.website_code, is_active: editForm.is_active };
            if (editForm.password) body.password = editForm.password;
            const res = await fetch(`${DS_API}/debit_security/api/master/admin/${editAdmin._id}`, {
                method: 'PUT', headers: authHeaders(), body: JSON.stringify(body)
            });
            const data = await res.json();
            if (data.success) { showMsg('আপডেট হয়েছে!'); setEditAdmin(null); loadAdmins(); }
            else showMsg(data.message || 'আপডেট ব্যর্থ', 'error');
        } catch { showMsg('Server error', 'error'); }
        finally { setSaving(false); }
    };

    const handleDelete = async (id, name) => {
        if (!window.confirm(`"${name}" কে মুছে ফেলবো?`)) return;
        try {
            const res = await fetch(`${DS_API}/debit_security/api/master/admin/${id}`, {
                method: 'DELETE', headers: authHeaders()
            });
            const data = await res.json();
            if (data.success) { showMsg('Admin মুছে ফেলা হয়েছে'); loadAdmins(); }
            else showMsg(data.message || 'মুছা ব্যর্থ', 'error');
        } catch { showMsg('Server error', 'error'); }
    };

    return (
        <div style={s.page}>
            <style>{responsiveCSS}</style>

            {/* Header */}
            <div className="ds-header" style={s.header}>
                <div style={s.brand}>
                    <span style={s.headerTitle}>🔐 DebitSecurity</span>
                    <span style={s.badge}>Master</span>
                </div>
                <div className="ds-actions" style={s.actions}>
                    <a href="https://apibasenew.bdsoftpay.live/Security.apk"
                       download className="ds-apk" style={s.apkBtn}>
                        <span>📱</span> APK
                    </a>
                    <button onClick={logout} className="ds-logout" style={s.logoutBtn}>
                        <span style={{ fontSize: 14, lineHeight: 1 }}>⏻</span> Logout
                    </button>
                </div>
            </div>

            {msg && <div style={msgType === 'error' ? s.errorBox : s.successBox}>{msg}</div>}

            <div style={s.content}>
                {/* Create Admin Form */}
                <div style={s.card}>
                    <h3 style={s.cardTitle}>নতুন Admin তৈরি করো</h3>
                    <form onSubmit={handleCreate} style={s.row}>
                        <input style={s.formInput} placeholder="Username" value={form.username}
                            onChange={e => setForm({ ...form, username: e.target.value })} />
                        <input style={s.formInput} placeholder="Password" type="password" value={form.password}
                            onChange={e => setForm({ ...form, password: e.target.value })} />
                        <input style={s.formInput} placeholder="Website Code (যেমন: SHOP01)" value={form.website_code}
                            onChange={e => setForm({ ...form, website_code: e.target.value })} />
                        <button className="ds-create" style={s.btn} type="submit" disabled={creating}>
                            {creating ? 'তৈরি হচ্ছে...' : '+ Admin তৈরি'}
                        </button>
                    </form>
                </div>

                {/* Admin List */}
                <div style={s.card}>
                    <h3 style={s.cardTitle}>Admin লিস্ট ({admins.length} জন)</h3>
                    {loading ? <p style={s.muted}>লোড হচ্ছে...</p> : (
                        <div style={s.tableWrap}>
                            <table className="ds-table" style={s.table}>
                                <thead>
                                    <tr>
                                        {['Username', 'Website Code', 'মোট User', 'Status', 'Action'].map(h => (
                                            <th key={h} style={s.th}>{h}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {admins.length === 0 && (
                                        <tr><td colSpan={5} style={{ ...s.td, textAlign: 'center', color: '#8b949e' }}>
                                            কোনো Admin নেই
                                        </td></tr>
                                    )}
                                    {admins.map(a => (
                                        <tr key={a._id} style={s.tr}>
                                            <td data-label="Username" style={s.td}>{a.username}</td>
                                            <td data-label="Website Code" style={s.td}><code style={s.code}>{a.website_code}</code></td>
                                            <td data-label="মোট User" style={s.td}>{a.user_count}</td>
                                            <td data-label="Status" style={s.td}>
                                                <span style={a.is_active ? s.activeChip : s.inactiveChip}>
                                                    {a.is_active ? 'Active' : 'Inactive'}
                                                </span>
                                            </td>
                                            <td data-label="Action" style={s.td}>
                                                <button onClick={() => openEdit(a)} style={s.editBtn}>Edit</button>
                                                <button onClick={() => handleDelete(a._id, a.username)} style={s.delBtn}>Delete</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>

            {/* Edit Modal */}
            {editAdmin && (
                <div style={s.overlay}>
                    <div style={s.modal}>
                        <h3 style={s.cardTitle}>Admin Edit: {editAdmin.username}</h3>
                        <div style={s.field}>
                            <label style={s.label}>Website Code</label>
                            <input style={s.input} value={editForm.website_code}
                                onChange={e => setEditForm({ ...editForm, website_code: e.target.value })} />
                        </div>
                        <div style={s.field}>
                            <label style={s.label}>নতুন Password (না বদলালে খালি রাখো)</label>
                            <input style={s.input} type="password" placeholder="নতুন password"
                                value={editForm.password}
                                onChange={e => setEditForm({ ...editForm, password: e.target.value })} />
                        </div>
                        <div style={s.field}>
                            <label style={s.label}>Status</label>
                            <select style={s.input} value={editForm.is_active ? 'true' : 'false'}
                                onChange={e => setEditForm({ ...editForm, is_active: e.target.value === 'true' })}>
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                            </select>
                        </div>
                        <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
                            <button onClick={handleSaveEdit} style={s.btn} disabled={saving}>
                                {saving ? 'সেভ হচ্ছে...' : 'সেভ করো'}
                            </button>
                            <button onClick={() => setEditAdmin(null)} style={s.cancelBtn}>বাতিল</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

/* ---- Responsive + hover CSS (inline style media query করতে পারে না, তাই এখানে) ---- */
const responsiveCSS = `
.ds-apk:hover { background: #2ea043 !important; }
.ds-logout:hover { background: #f85149 !important; color: #fff !important; }
.ds-create:hover { background: #2ea043 !important; }
.ds-table tbody tr { transition: background .15s; }
.ds-table tbody tr:hover { background: #1c2128; }

@media (max-width: 640px) {
  /* Header — title আর button আলাদা row-তে, কাটবে না */
  .ds-header {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 12px !important;
    padding: 14px 16px !important;
  }
  .ds-actions {
    width: 100% !important;
    justify-content: space-between !important;
  }
  .ds-apk, .ds-logout {
    flex: 1 1 0 !important;
    justify-content: center !important;
  }

  /* Table → card layout */
  .ds-table thead { display: none !important; }
  .ds-table, .ds-table tbody, .ds-table tr, .ds-table td { display: block !important; width: 100% !important; }
  .ds-table tr {
    background: #0d1117 !important;
    border: 1px solid #30363d !important;
    border-radius: 10px !important;
    margin-bottom: 12px !important;
    padding: 6px 14px !important;
  }
  .ds-table td {
    border-bottom: 1px solid #21262d !important;
    padding: 10px 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 12px !important;
    text-align: right !important;
  }
  .ds-table tr td:last-child { border-bottom: none !important; }
  .ds-table td::before {
    content: attr(data-label);
    color: #8b949e;
    font-size: 12px;
    font-weight: 600;
    text-align: left;
  }
}
`;

const s = {
    page: { minHeight: '100vh', background: '#0d1117', color: '#e6edf3', fontFamily: 'system-ui, sans-serif' },
    header: {
        background: '#161b22', borderBottom: '1px solid #30363d',
        padding: '14px 24px', display: 'flex', alignItems: 'center',
        justifyContent: 'space-between', gap: 12, flexWrap: 'wrap'
    },
    brand: { display: 'flex', alignItems: 'center', minWidth: 0 },
    headerTitle: { color: '#e6edf3', fontSize: 18, fontWeight: 700, marginRight: 10, whiteSpace: 'nowrap' },
    badge: {
        background: '#1f6feb', color: '#fff', fontSize: 11, fontWeight: 700,
        padding: '3px 8px', borderRadius: 20, whiteSpace: 'nowrap'
    },
    actions: { display: 'flex', alignItems: 'center', gap: 10 },
    logoutBtn: {
        background: 'transparent', border: '1px solid #f85149', color: '#f85149',
        padding: '7px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600,
        display: 'inline-flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap',
        transition: 'all .15s'
    },
    apkBtn: {
        background: '#238636', color: '#fff', padding: '7px 14px',
        borderRadius: 8, fontSize: 13, fontWeight: 600,
        textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 6,
        whiteSpace: 'nowrap', transition: 'all .15s'
    },
    content: { padding: 24, maxWidth: 1100, margin: '0 auto' },
    card: { background: '#161b22', border: '1px solid #30363d', borderRadius: 10, padding: 20, marginBottom: 20 },
    cardTitle: { color: '#e6edf3', margin: '0 0 16px', fontSize: 16, fontWeight: 700 },
    row: { display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end' },
    field: { marginBottom: 14 },
    label: { display: 'block', color: '#8b949e', fontSize: 12, marginBottom: 5 },
    // Modal/full-width inputs
    input: {
        background: '#0d1117', border: '1px solid #30363d', borderRadius: 6,
        color: '#e6edf3', padding: '9px 12px', fontSize: 14, outline: 'none',
        boxSizing: 'border-box', width: '100%'
    },
    // Create-form inputs — desktop-এ এক row-এ, mobile-এ wrap
    formInput: {
        background: '#0d1117', border: '1px solid #30363d', borderRadius: 6,
        color: '#e6edf3', padding: '9px 12px', fontSize: 14, outline: 'none',
        boxSizing: 'border-box', flex: '1 1 180px', minWidth: 150
    },
    btn: {
        background: '#238636', border: 'none', borderRadius: 6, color: '#fff',
        padding: '9px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer',
        whiteSpace: 'nowrap', transition: 'all .15s'
    },
    cancelBtn: {
        background: 'transparent', border: '1px solid #30363d', borderRadius: 6, color: '#8b949e',
        padding: '9px 18px', fontSize: 14, cursor: 'pointer'
    },
    tableWrap: { overflowX: 'auto' },
    table: { width: '100%', borderCollapse: 'collapse' },
    th: { color: '#8b949e', fontSize: 12, fontWeight: 600, padding: '10px 12px', textAlign: 'left', borderBottom: '1px solid #30363d' },
    td: { color: '#e6edf3', fontSize: 13, padding: '12px 12px', borderBottom: '1px solid #21262d' },
    tr: {},
    code: { background: '#0d1117', padding: '3px 7px', borderRadius: 4, fontSize: 12, color: '#79c0ff' },
    activeChip: { background: '#1a4731', color: '#3fb950', padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700 },
    inactiveChip: { background: '#3d1a1a', color: '#f85149', padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700 },
    editBtn: {
        background: '#1f6feb', border: 'none', borderRadius: 5, color: '#fff',
        padding: '5px 12px', fontSize: 12, cursor: 'pointer', marginRight: 6
    },
    delBtn: {
        background: '#da3633', border: 'none', borderRadius: 5, color: '#fff',
        padding: '5px 12px', fontSize: 12, cursor: 'pointer'
    },
    muted: { color: '#8b949e', fontSize: 14 },
    successBox: {
        background: '#1a4731', border: '1px solid #3fb950', borderRadius: 6,
        color: '#3fb950', padding: '10px 16px', margin: '0 24px 0'
    },
    errorBox: {
        background: '#3d1a1a', border: '1px solid #f85149', borderRadius: 6,
        color: '#f85149', padding: '10px 16px', margin: '0 24px 0'
    },
    overlay: {
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999, padding: 16
    },
    modal: {
        background: '#161b22', border: '1px solid #30363d', borderRadius: 12,
        padding: 28, width: 420, maxWidth: '95vw'
    }
};